<template>
  <div>
    <slot name="label">
      <h2 class="mb-0">{{ $t('personalizedWalletCard.customize.headline.label') }}</h2>
    </slot>
    <b-row class="mt-2 mx-0">
      <b-col class="py-1 px-0">
        <DpSelect v-model="selectedHeadline" :options="options" class="notranslate" translate="no" @input="selectHeadline" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import getImage from '@/mixins/getImage';
import DpSelect from '@/components/library/Select';

export default {
  name: 'WalletCardHeadlineSelect',
  components: {
    DpSelect,
  },
  mixins: [getImage],
  props: {
    options: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedHeadline: null,
    };
  },
  created() {
    if (!this.selectedHeadline && this.options.length >= 1) {
      this.selectHeadline(0);
    }
  },
  methods: {
    selectHeadline(headlineIndex) {
      const headlineText = this.options.find((option) => option.value == headlineIndex).text;
      this.$emit('selectedHeadline', headlineText);
    },
  },
};
</script>

<style lang="scss"></style>
